<template>
  <div class="titleCard">
    <p>{{title}}</p>
    <span></span>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      require: true,
    }
  },
  data() {
    return {

    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.titleCard {
  text-align: center;
  p {
    padding-bottom: 0.3789rem;
    font-size: 0.4421rem;
    @media screen and (max-width: 540px) {
      font-size: 1.1579rem;
    }
    font-weight: 700;
    color: #000000;
    letter-spacing: 0.0526rem;
  }
  span {
    margin: 0 auto;
    position: relative;
    display: block;
    width: 3.0947rem;
    height: 0.0421rem;
    @media screen and (max-width: 540px) {
      width: 9.4737rem;
      height: 0.1263rem;
    }
    background-color: #dadbdb;
  }
  span::after {
    content: '';
    position: absolute;
    left: 50%;
    margin-left: -0.2947rem;
    bottom: -0.0105rem;
    width: 0.5895rem;
    height: 0.0842rem;
    background-color: #0ca6eb;
    @media screen and (max-width: 540px) {
      width: 1.6842rem;
      height: 0.2211rem;
      margin-left: -0.8421rem;
    }
  }
}
</style>
